import {
    CartItemPrice as SourceCartItemPrice
} from 'SourceComponent/CartItemPrice/CartItemPrice.component';
import { formatPrice, roundPrice } from 'Util/Price';

/** @namespace Bodypwa/Component/CartItemPrice/Component */
export class CartItemPriceComponent extends SourceCartItemPrice {
    renderPrice() {
        const {
            price, currency_code, regular_price, qty, percentOff
        } = this.props;
        const value = roundPrice(price);
        const isDiscounted = !!(regular_price && (regular_price.value * qty).toFixed(1) !== price.toFixed(1));
        const hasRegularPrice = isDiscounted && percentOff ? '_hasRegularPrice' : '';

        return (
            <>
                <span aria-label={ __('Current product price') } className={ `CurrentPrice ${hasRegularPrice}` }>
                    <data value={ value }>{ formatPrice(price, currency_code) }</data>
                </span>
                { isDiscounted && percentOff ? (
                    <span aria-label={ __('Old price') } className="RegularPrice">
                        { /* eslint-disable-next-line no-magic-numbers */ }
                        <data value={ price / (1 - percentOff / 100) }>
                            { /* eslint-disable-next-line no-magic-numbers */ }
                            { formatPrice((price / (1 - percentOff / 100)), currency_code) }
                        </data>
                    </span>
                ) : null }
            </>
        );
    }

    render() {
        const { mix } = this.props;

        return (
            <p block="ProductPrice" aria-label={ __('Product Price') } mix={ mix }>
                { this.renderPrice() }
                { this.renderSubPrice() }
            </p>
        );
    }
}

export default CartItemPriceComponent;
